import * as React from "react";
import { TYPE_FOLD, TYPE_IGNORE, DXFSpace } from "../nodedxf2";
import { floodFill } from "./FloodFill";
import { DrawLine } from "./DrawLine";
import { ArcLine } from "./ArcLine";
import { Point } from "../DrawingObj";
const CanDraw = ["LINE", "ARC", "CIRCLE", "POLYGON", "POLYLINE"];
let findTouching = (objs, t) => {
    return objs
        .filter((v) => (v.Type = "LINE"))
        .filter((drawable) => {
        if (drawable.id == t.id)
            return false;
        return (drawable.points
            .map((element) => t.points.map((p) => p.touching(element)))
            .flat()
            .filter((v) => v).length > 0);
    });
};
function distance(a, b, c) {
    // normalize points
    let cn = { x: c.x - a.x, y: c.y - a.y };
    let bn = { x: b.x - a.x, y: b.y - a.y };
    let angle = Math.atan2(bn.y, bn.x) - Math.atan2(cn.y, cn.x);
    let abLength = Math.sqrt(bn.x * bn.x + bn.y * bn.y);
    return Math.sin(angle) * abLength;
}
function closestPoint(point, lines, contour) {
    if (!point)
        return null;
    let closestDistance = Number.MAX_VALUE;
    let closestLine;
    lines.forEach((line) => {
        if (line.points.length >= 0) {
            let p = line.points[line.points.length - 1];
            line.points.forEach((p2) => {
                let d = point.distanceTo(p2);
                // let d = distance(p, p2, point);
                if (d < closestDistance) {
                    closestDistance = d;
                    closestLine = line;
                }
                p = p2;
            });
        }
    });
    return closestLine;
}
function DrawPoint(point, canvas) {
    canvas.beginPath();
    canvas.arc(point.x, point.y, 2, 0, 2 * Math.PI, true);
    canvas.fill();
    canvas.stroke();
}
export let Drawing = (props) => {
    const canvasRef = React.useRef(null);
    let [lastPt, setLastPt] = React.useState(null);
    let [hoverIds, setHoverIds] = React.useState([]);
    var ids = props.ids;
    var drawing = props.drawing;
    if (!drawing) {
        throw new Error("Drawing needs a drawing object");
    }
    let toDraw = drawing
        ? drawing.Drawables.filter((o) => CanDraw.includes(o.named))
        : [];
    let [contour, setContour] = React.useState(drawing.calcContour());
    contour.maxlen = Math.max(contour.width, contour.height);
    let handleMouseMove = (event) => {
        //React.MouseEventHandler<Element>
        let rect = canvasRef.current.getBoundingClientRect();
        let canvasPoint = Point.fromXYZ(event.clientX - rect.left, event.clientY - rect.top, 0);
        if (props.onMouseMove) {
            let drawingPoint = contour.reverseScale(canvasPoint);
            props.onMouseMove(event, canvasPoint, drawingPoint);
        }
        setLastPt(canvasPoint);
    };
    let handleClick = (event) => {
        if (props.setIds) {
            props.setIds(hoverIds);
        }
        if (props.onClick)
            props.onClick(event);
    };
    // React.useEffect(() => {
    //   if (lastPt) {
    //     let localpt = lastPt;
    //     if (canvasRef.current) {
    //       localpt = Point.fromXYZ(
    //         localpt.x,
    //         canvasRef.current.height - localpt.y,
    //         0
    //       );
    //     }
    //     let p = closestPoint(localpt, toDraw, contour);
    //     setHoverIds(p ? [p.id] : []);
    //   }
    // }, [lastPt]);
    React.useEffect(() => {
        var _a;
        let canvas = canvasRef.current;
        if (!contour.scalefator ||
            contour.canvas_width != canvas.width ||
            contour.canvas_height != canvas.height) {
            contour.scalefator =
                Math.max(canvas.width, canvas.height) / contour.maxlen;
            contour.scalefator = (contour.scalefator * 9) / 10;
            contour.canvas_width = canvas.width;
            contour.canvas_height = canvas.height;
            setContour(contour);
        }
        //ontour.canvas = canvasRef.current;
        const context = canvas.getContext("2d", { willReadFrequently: true }); //willReadFrequently is needed for floodfill
        // debug(contour);
        context.fillStyle = "white";
        context.strokeStyle = "black";
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.fillStyle = "white";
        // let counts: string[] = [];
        toDraw
            .filter((o) => !(o instanceof DXFSpace.DXFOBJECT))
            .map((o) => {
            var _a;
            try {
                let selected = ids ? ids.includes(o.id) : false;
                context.strokeStyle = "black";
                context.lineWidth = 1;
                context.setLineDash([]);
                if (o.Type == TYPE_IGNORE && !selected)
                    return;
                //TYPE_FOLD, TYPE_CUT , TYPE_IGNORE
                switch (o.Type) {
                    case TYPE_FOLD:
                        context.strokeStyle = "red";
                        context.lineWidth = 1;
                        context.setLineDash([5, 5]);
                        break;
                    case TYPE_IGNORE:
                        context.strokeStyle = "lightgrey";
                        context.lineWidth = 1;
                        break;
                }
                if (selected) {
                    context.strokeStyle = "red";
                    context.lineWidth = 3;
                }
                if (hoverIds.includes(o.id)) {
                    context.strokeStyle = "blue";
                    context.lineWidth = 3;
                }
                // if (props.debug)
                //   o.points.map((v) => DrawPoint(contour.scale(v), context));
                //   counts.push(o.named)
                switch (o.named) {
                    case "POLYGON":
                    case "POLYLINE":
                    case "LINE":
                        DrawLine(o, context, contour, (_a = drawing.bends) !== null && _a !== void 0 ? _a : []);
                        break;
                    case "CIRCLE":
                    case "ARC":
                        let a = o;
                        //console.log("ARCARC", o);
                        ArcLine(a, context, contour);
                        if (props.debug && selected) {
                            context.strokeStyle = "yellow";
                            context.fillStyle = "yellow";
                            a.ArcPoints.map((v) => DrawPoint(contour.scale(v), context));
                        }
                        break;
                }
                //   o.points.forEach((p) => DrawPoint(contour.scale(p), context));
            }
            catch (error) {
                console.error("Drawing to Draw Errrror", o.named, error);
                drawing.addError(o.named + ": " + error);
            }
        });
        floodFill(context, 1, 1, [51, 102, 255, 128]);
        let fontHeight = 10;
        context.font = fontHeight + "pt Courier New";
        context.fillStyle = "black";
        let caption = (_a = props.heading) !== null && _a !== void 0 ? _a : "";
        if (props.index) {
            caption = "#" + props.index + " " + caption;
        }
        if (props.color) {
            let text = context.measureText(props.color);
            context.fillText(props.color, canvas.width - text.width, canvas.height - fontHeight + fontHeight / 2);
        }
        if (caption) {
            context.fillText(caption, 0, canvas.height - fontHeight + fontHeight / 2);
        }
        // console.log(contour);
        context.fillText(" " +
            Math.round(contour.height * 1000) / 1000 +
            "mm X " +
            Math.round(contour.width * 1000) / 1000 +
            "mm", 0, fontHeight + fontHeight / 2);
        // context.fillText(
        //   " CutLen: " + Math.round(contour.Cuts.totallen * 1000) / 1000 + "mm",
        //   0,
        //   fontHeight + fontHeight+ fontHeight 
        // );
        if (drawing.errors && drawing.errors.length > 0) {
            context.fillStyle = "red";
            context.fillText("Error Loading DXF", 10, fontHeight * 4);
            drawing.errors.map((v, i) => {
                context.fillText(i + 1 + ": " + v, 10, fontHeight * (i + 2) + fontHeight * 4);
            });
        }
        if (!toDraw || toDraw.length === 0) {
            context.fillStyle = "red";
            context.fillText("Sorry,Failed to find anything to draw", 10, canvas.height - fontHeight * 3);
        }
        if (props.debug) {
            context.strokeStyle = "lime";
            context.fillStyle = "darkgreen";
            DrawPoint(contour.scale(Point.fromXYZ(contour.min.x, contour.min.y)), context);
            DrawPoint(contour.scale(Point.fromXYZ(contour.max.x, contour.max.y)), context);
        }
        //if (lastPt) DrawPoint(lastPt, context);
    }, [ids, drawing, hoverIds, props.Height, props.Width]);
    return (React.createElement("canvas", { ref: canvasRef, width: typeof props.Width == "string" ? props.Width : props.Width + "px", height: props.Height + "px", "data-heading": props.heading, onMouseMove: handleMouseMove, onClick: handleClick, style: { cursor: "zoom-in" } }));
};
